<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <employee-claims-apply-on-behalf-table-list :employee-uid="employee.employee_uid" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    components: {
      EmployeeClaimsApplyOnBehalfTableList: () => import('@/components/employee/claims/on-behalfs/TableList'),
    },
    metaInfo () {
      return {
        title: 'Claim Apply On Behalf',
      }
    },
    computed: {  
      ...mapState({ employee: 'currentEmployee' }),
    },
  }
</script>
